import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, UserService } from '../../shared';

@Component({
  selector: 'app-code',
  templateUrl: './code.component.html',
  styleUrls: ['../style.component.css', './code.component.css']
})
export class CodeComponent implements OnInit {
  show: boolean;
  public timealert = environment.timelimit;
  public Patpro = {
    otpassword: "",
    otpState: ""
  }
  otpid: any;
  patid: any;
  welcome: any;
  modalRef: any;
  resdata: any;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }

  constructor(
    private patientservice: PatientService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private toast: ToastrService,
    private userService: UserService,
    private nav: Router
  ) { }

  ngOnInit() {
    // ////console.log("id");


    this.routerr.params.subscribe(params => {
      this.patid = params

      // ////console.log("id",this.patid,params);
    });


    this.patientservice
      .getacid(this.patid.id)
      .subscribe(
        data => {
          if (data.status == "success") {
            // ////console.log("message sent")
            this.toast.success(this.userService.translateText('patient_portal.display_messages.email_sms_sent.success'), '', {
              timeOut: this.timealert
            })
            this.otpid = data.OTP;
            // ////console.log("otp",this.otpid)
          }
        }
      )

  }
  reg() {

    this.patientservice
      .getacid(this.patid.id)
      .subscribe(
        data => {
          if (data.status == "success") {
            // ////console.log("message sent")
            this.toast.success(this.userService.translateText('patient_portal.display_messages.email_sms_sent.success'), '', {
              timeOut: this.timealert
            })
          }
        }
      )


  }
  otp(msg) {
    // ////console.log(msg.value)
    let sms = {
      "userAccountId": this.patid.id,
      "otpassword": msg.value.otpassword
    }
    // ////console.log(sms)

    // if(msg.value.otpassword == this.otpid){
    //   this.nav.navigate([`/resetpass/${this.patid.id}`])
    // }
    // else if(msg.value.otpassword != this.otpid){
    //   this.toast.error("OTP Not Matched!")
    // }
    // else{
    //   this.toast.error("Enter OTP again")
    // }
    this.patientservice
      .getotp(sms)
      .subscribe(
        data => {
          // ////console.log(data)

          if ((data.status == "success") && (data.messasge == "OTP Matched!")) {
            //  ////console.log("in")
            this.nav.navigate([`/resetpass/${this.patid.id}`])
          }
          else if ((data.status == "success") && (data.otpStatus == "OTP Not Matched!")) {
            this.toast.error(this.userService.translateText('patient_portal.display_messages.otp_not_match'), '', {
              timeOut: this.timealert
            })
          }
        }
      )
  }

  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }


}
